/**
 * Call to dynamically create a evo contact form. Must be called before document ready.
 * @param {string} selector Selector in which the form will be appended to.
 * @param {string} sendToEmail Email address the form will be sent to.
 * @param {string} formstructure https://docs.evolutionx.io/en/articles/3436146-custom-contact-forms
 */
const insertCustomForm = (selector) => {
  const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  const gcaptcha = document.querySelector('meta[name*=gr-sitekey]').getAttribute('content');

  const captcha = document.createElement('script');
  captcha.src = 'https://www.google.com/recaptcha/api.js';
  document.querySelector('body').append(captcha);

  selector.insertAdjacentHTML('beforeend', /* html */ `
<form class="register-form nFlex" method="post" action="https://officebasics.us.evostore.io/register">
  <input type="hidden" name="_token" value="${token}">
  <div style="position: absolute; left: -5000px;" aria-hidden="true">
    <span class="bmd-form-group">
      <input type="text" name="bt_9069dd52a0e874ee7de9f2fec_a530ab65d1" tabindex="-1" value="" autocomplete="off">
    </span>
  </div>
  
<div class="su-details-input nFlex">
  <div class="form-group su-name">
    <input type="text" class="form-control" name="name" id="name" placeholder="Name *" required="">
  </div>

  <div class="form-group su-email">
    <input type="email" class="form-control" name="emailaddress" id="emailaddress" placeholder="Email *" required="">
  </div>

  <div class="form-group psw-meter su-password">
    <input type="password" class="form-control" name="password" id="password" placeholder="Password" required>
  </div>

  <div class="form-group phone-wrapper su-phone">
    <select name="phone_type" class="form-control phone"><option value="cell">Cell</option><option value="phone">Phone</option></select>
    <input type="text" class="form-control" name="phone" id="phone" pattern="(^$)|(.{2,}.*\S.*)" title="Please enter a valid phone" placeholder="00000 000000">
  </div>
</div>

<div class="su-checkbox nFlex">
  <div class="form-group has-checkboxes su-credit">
    <label for="credit_status" class="control control--checkbox">
      <input id="credit_status" type="checkbox" name="credit_status" value="1">Request A Credit Account?
      <div class="control__indicator"></div>
    </label>
    <i class="fa fa-info-circle has-tooltip" title="Apply to set up credit account and pay for goods on agreed terms."></i>
  </div>

  <div class="form-group has-checkboxes">
    <label for="termsandconditionscheck" class="control control--checkbox">
      <input id="termsandconditionscheck" type="checkbox" name="" required>Accept Terms And Conditions *
      <div class="control__indicator"></div>
    </label>
  </div>
  
  <div class="form-group small t-c-text">
    By checking the box above and clicking create account, you acknowledge you have read and agreed to our <strong><a href="/terms-conditions" target="_blank">Terms And Conditions</a></strong>.
  </div>
  
  <div class="form-group has-checkboxes">
    <label for="newsletter_status" class="control control--checkbox">
      <input id="newsletter_status" type="checkbox" name="newsletter_status" value="1" > Receive Special Offers                  <div class="control__indicator"></div>
    </label>
  </div>

  <div class="g-recaptcha" data-sitekey="${gcaptcha}" data-callback="enableSubmit"></div>
  
  <div class="form-group">
    <button type="submit" class="nButton">Create Account</button>
  </div>
</div>
</form>
  `);
};

/**
 * login modal
 */
(() => {
  const loginModal = document.getElementById('loginModal');
  if (loginModal) loginModal.classList.add('login-modal');

  const modalContent = loginModal.querySelector('.modal-content');
  const loginDetails = loginModal.querySelectorAll('.modal-content > *');
  const signupContent = document.querySelector('footer .signup-content');
  insertCustomForm(signupContent.querySelector('.form-wrapper .form'));
  const sideImage = document.querySelector('.js-login-modal .login-image-wrapper');
  sideImage.style.display = 'block';
  const subTitle = document.querySelector('.js-login-modal .sub-title');
  subTitle.style.display = 'block';
  const closeButton = modalContent.querySelector('.modal-header').cloneNode(true);

  const newLoginModal = document.createElement('div');
  newLoginModal.className = 'modal-content login-page';

  newLoginModal.innerHTML = /* html */`
    <div class="nLeft">
      ${sideImage.outerHTML}
    </div>
    <div class="nRight">
      <div class="header">
        <h2 class="login nActive">Login</h2>
        <a href="/request-an-account" class="sign-up h2">Create Account</a>
      </div>
      <div class="login-content content nActive">
        ${subTitle.outerHTML}
        ${[...loginDetails].map((detail) => detail.outerHTML).join('')}
      </div>
      <div class="sign-up-content content">
        ${closeButton.outerHTML}
        ${signupContent.outerHTML}
      </div>
    </div>
  `;

  modalContent.replaceWith(newLoginModal);

  // header click function
  const loginHeader = newLoginModal.querySelector('.header .login');
  const signUpHeader = newLoginModal.querySelector('.header .sign-up');
  const loginContent = newLoginModal.querySelector('.login-content');
  const signUpContent = newLoginModal.querySelector('.sign-up-content');
  signUpContent.querySelector('.signup-content').classList.remove('hidden');
  const image = newLoginModal.querySelector('.nLeft');
  loginHeader.addEventListener('click', () => {
    if (signUpHeader.classList.contains('nActive')) {
      signUpContent.classList.remove('nActive');
      signUpHeader.classList.remove('nActive');
      loginContent.classList.add('nActive');
      loginHeader.classList.add('nActive');
      image.classList.remove('signup');
    }
  });
  signUpHeader.addEventListener('click', () => {
    // if (loginHeader.classList.contains('nActive')) {
    //   loginContent.classList.remove('nActive');
    //   loginHeader.classList.remove('nActive');
    //   signUpContent.classList.add('nActive');
    //   signUpHeader.classList.add('nActive');
    //   image.classList.add('signup');
    // }
  });

  // move forgot password into remember me container
  const rememberMe = newLoginModal.querySelector('.login-remember');
  const forgotPassword = newLoginModal.querySelector('.login-links .pull-left');
  rememberMe.append(forgotPassword);

  // add js-signin to show login modal on click
  const header = document.querySelector('.header-full');
  if (!header) return;
  document.querySelectorAll('.shoppingtools_container .dropdown').forEach((item) => {
    item.querySelectorAll('.dropdown-menu.account-dropdown').forEach((el) => {
      el.remove();
    });
    if (item.querySelector(':scope > a')) {
      item.querySelector(':scope > a').setAttribute('href', '#');
      item.querySelector(':scope > a').setAttribute('data-toggle', 'modal');
      item.querySelector(':scope > a').setAttribute('data-target', '#loginModal');
    } else {
      item.setAttribute('data-toggle', 'modal');
      item.setAttribute('data-target', '#loginModal');
    }
  });
})();
